import styled from 'styled-components';
import { colors } from '../../../utils/colors';
import { bootstrapMax, bootstrapMin } from '../../../utils/devices';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import imgLinkedin from '../../../assets/icons/social_media/linkedin-blue.svg';
import imgFacebook from '../../../assets/icons/social_media/facebook-blue.svg';
import imgInstagram from '../../../assets/icons/social_media/instagram-blue.svg';
import imgYoutube from '../../../assets/icons/social_media/youtube-blue.svg';
import externalIcon from '../../../assets/icons/social_media/external-icon.svg';

export const Title = styled.h2`
  font-family: 'Trade Gothic LT Bold';
  color: ${colors.primaryThree};
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0;

  @media ${bootstrapMin.lg} {
    font-size: 26px;
    line-height: 40px;
  }
`;

export const ContainerSocialMedia = styled.div`
  display: flex;
  padding-left: 10px;
  gap: 20px;

  @media ${bootstrapMin.lg} {
    margin-top: 15px;
    gap: 30px;
  }
`;

export const IconSocialMedia = styled.div`
  background-image: url(${({ facebook, instagram, youtube }) => {
    if (facebook) return imgFacebook;
    else if (instagram) return imgInstagram;
    else if (youtube) return imgYoutube;
    else return imgLinkedin;
  }});
  background-size: contain;
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;

  @media ${bootstrapMin.lg} {
    width: 35px;
    height: 35px;
  }
`;

export const ExternalIcon = styled.div`
  background-image: url(${externalIcon});
  width: 24px;
  height: 24px;
  background-size: contain;
  margin-left: 18px;
`

export const Textsbody = styled.p`
   {
    font-family: 'Trade Gothic LT';
    text-align: start;
    font-size: 14px;
    margin-top: 15px;
    padding: 10px;
  }
  @media ${bootstrapMin.lg} {
    font-size: 20px;
  }
`;

export const Pressimg = styled.img`
   {
    border-radius: 30px;
    width: 29%;
  }
`;


export const StyledLink = styled(Link)`
   {
    font-family: 'Trade Gothic LT';
    cursor: pointer;
    margin-top: 10px;
    font-weight: bold;
  }
`;

export const ProgramsText = styled.p`
   {
    font-family: 'Trade Gothic LT';
    font-size: 15px;
    text-align: start;
    line-height: 24px;
    margin: 20px;
  }
  @media ${bootstrapMin.lg} {
    font-size: 20px;
  }
`;

export const WorkContainer = styled.div`
  @media ${bootstrapMax.sm} {
    & .MuiButtonBase-root {
      font-size: 15.5px !important;
    }

    & .container-doubt {
      margin: 0 -20px;

      & .col-doubt {
        padding-right: 0;
      }
    }
  }

  @media ${bootstrapMax.lg} {
    padding: 0 12px;
  }
`;

export const RowStyled = styled(Row)`
  @media ${bootstrapMax.sm} {
    padding: 0 8px;
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
`;
